<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title">{{ t('Confirm close modal header (confirm close modal) - Are you sure you want to close?') }}</h4>
    </div>
    <div class="modal-body">
        <p>{{ t('Confirm close modal body (confirm close modal) - Your progress will be lost if you close') }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="confirmClose()" rippleEffect>
            {{ t('Yes button text (confirm close modal) - Yes, close') }}
        </button>
        <button type="button" class="btn btn-success" (click)="closeModel()" rippleEffect>
            {{ t('Cancel button text (cancel button) - cancel') }}
        </button>
    </div>
</ng-container>